import styled from 'styled-components';
import { useTextVariant } from '../../../hook/useTextVariant';
import {
  WARING_MODAL_CONSTANTS,
  SATELLITE_ITEMS,
  MAIN_EVENT_ITEMS,
} from '../../../constants/waringModal';
import { WaringModalViewProps } from '../WaringModal';

export const WaringModalPc = ({ visible = false, close }: WaringModalViewProps) => {
  const { getText } = useTextVariant(WARING_MODAL_CONSTANTS, false);

  return (
    <ModalWrap $visible={visible}>
      <Dim />
      <ModalContent $visible={visible}>
        <Title>{getText('title')}</Title>
        <Content>
          <ContentTitle>{getText('satelliteTitle')}</ContentTitle>
          <Inner>
            {SATELLITE_ITEMS.map((item, i) => (
              <ContentListItem key={i}>{item}</ContentListItem>
            ))}
          </Inner>
          <ContentTitle>{getText('mainEventTitle')}</ContentTitle>
          {MAIN_EVENT_ITEMS.map((item, i) => (
            <ContentListItem key={i}>{item}</ContentListItem>
          ))}
        </Content>
        <ButtonContainer onClick={close}>
          <ConfirmButton>{getText('confirmBtn')}</ConfirmButton>
        </ButtonContainer>
      </ModalContent>
    </ModalWrap>
  );
};

const ConfirmButton = styled.button`
  width: 130px;
  height: 46px;
  border-radius: 25px;
  background: #5200d3;
  box-shadow:
    0 -1px 0 0 rgba(104, 104, 104, 0.3) inset,
    0 2px 0 0 rgba(0, 0, 0, 0.15),
    0 1px 1px 0 rgba(173, 166, 153, 0.5) inset;
  color: #fff;
  text-align: center;
  font-size: 20px;
  font-weight: 500;
  line-height: 18px;
  letter-spacing: -1.2px;
  cursor: pointer;
  transition:
    transform 0.1s ease,
    box-shadow 0.1s ease;

  &:active {
    transform: translateY(2px) scale(0.97);
    box-shadow:
      0 -1px 0 0 rgba(104, 104, 104, 0.3) inset,
      0 0px 0 0 rgba(0, 0, 0, 0.15),
      0 1px 1px 0 rgba(173, 166, 153, 0.5) inset;
  }
`;

const ButtonContainer = styled.div`
  width: 100%;
  position: absolute;
  height: 74px;

  left: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding-right: 10px;

  border-radius: 0px 0px 20px 20px;
  background: #222120;
`;

const ModalWrap = styled.div<{ $visible: boolean }>`
  visibility: ${({ $visible }) => ($visible ? 'visible' : 'hidden')};
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 10000000;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Dim = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.8);
`;

const ModalContent = styled.div<{ $visible: boolean }>`
  max-width: 520px;
  background: #302e2d;
  box-shadow: 0px 1px 1px 0px rgba(255, 255, 255, 0.2) inset;
  position: relative;
  z-index: 2;
  transform: ${({ $visible }) => ($visible ? 'scale(1)' : 'scale(0.75)')};
  transition: transform 0.15s ease-in-out;
  border-radius: 20px 20px 0px 0px;
  padding: 25px 30px 15px 30px;
  padding-bottom: 0;
  overflow-y: auto;
  height: 634px;
  border-bottom-left-radius: 20px;
  border-bottom-right-radius: 20px;
`;

const ContentTitle = styled.h3`
  color: rgba(255, 255, 255, 0.8);
  font-size: 15px;
  font-weight: 700;
  line-height: 18px;
  letter-spacing: -1.04px;
  margin-bottom: 20px;
`;

const Content = styled.ul`
  border-radius: 8px;
  background: #201f1e;
  padding: 20px 10px;
  list-style: none;
  display: flex;
  flex-direction: column;
  height: 467px;
  overflow-y: auto;
`;

const Inner = styled.div`
  margin-bottom: 30px;
`;

const ContentListItem = styled.li`
  color: #b2b2b2;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: -0.39px;
  margin-bottom: 5px;
  position: relative;
  padding-left: 10px;

  &:after {
    content: '';
    width: 3px;
    height: 3px;
    position: absolute;
    background-color: #b2b2b2;
    top: 10px;
    left: 0;
    border-radius: 50%;
  }

  &:last-child {
    margin-bottom: 0;
  }
`;

const Title = styled.h3`
  color: #eee;
  text-align: center;
  font-size: 24px;
  font-weight: 600;
`;
